export interface LocationData {
  id: string
  name: string
  city: string
  address: string
  phone: string
  highlights: string[]
  schedule?: DaySchedule[]
  hasSchedule: boolean
}

export interface DaySchedule {
  day: string
  classes: ClassTime[]
}

export interface ClassTime {
  time: string
  name: string
}

export const GLOBAL_PHONE = '989-280-3402'

export const locations: LocationData[] = [
  {
    id: 'midland',
    name: 'Midland (Flagship)',
    city: 'Midland',
    address: '6800 Eastman Avenue, Suite 400–404, Midland, Michigan',
    phone: GLOBAL_PHONE,
    highlights: [
      'Flagship Location',
      'Competition Team',
      'Large Training Floor',
    ],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Mini Kickers (Preschool, ages 3–5)' },
          { time: '5:35–6:25 PM', name: 'Beginner Class (White–Green Stripe)' },
          {
            time: '6:30–7:30 PM',
            name: 'Advanced Class (Green Belt and Above)',
          },
        ],
      },
      {
        day: 'Tuesday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Beginner Class (Forms / Poomsae)' },
          { time: '6:00–7:00 PM', name: 'ITF Taekwondo (All Belts)' },
          { time: '6:30–7:30 PM', name: 'Advanced Class (Forms / Poomsae)' },
        ],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Traditional Class (All Belts)' },
          { time: '6:30–7:30 PM', name: 'Sparring Class (All Belts)' },
        ],
      },
      {
        day: 'Thursday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Mini Kickers (Preschool, ages 3–5)' },
          {
            time: '5:35–6:25 PM',
            name: 'Beginner Class (Sparring / Conditioning)',
          },
          { time: '6:00–7:00 PM', name: 'ITF Taekwondo (All Belts)' },
          {
            time: '6:30–7:30 PM',
            name: 'Advanced Class (Sparring / Conditioning)',
          },
        ],
      },
      {
        day: 'Friday',
        classes: [
          { time: '5:00–5:30 PM', name: 'Mini Kickers (Preschool, ages 3–5)' },
          { time: '5:35–6:20 PM', name: 'Traditional Class (All Belts)' },
          { time: '6:30–8:00 PM', name: 'Competition Class' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '1:00–2:00 PM', name: 'Bo Staff Class ($5 Drop-In)' },
          { time: '2:00–3:30 PM', name: 'Competition Class' },
        ],
      },
    ],
  },
  {
    id: 'saginaw',
    name: 'Saginaw – Fashion Square Mall',
    city: 'Saginaw',
    address: '4655 Fashion Square Mall, Saginaw, Michigan',
    phone: GLOBAL_PHONE,
    highlights: ['New Location', 'Tang Soo Do', 'Mall Convenience'],
    hasSchedule: true,
    schedule: [
      {
        day: 'Tuesday and Thursday',
        classes: [
          { time: '5:30–6:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '6:05–6:55 PM', name: 'Beginner Class (ages 6 and up)' },
          { time: '7:05–8:00 PM', name: 'Advanced Class' },
        ],
      },
      {
        day: 'Monday, Wednesday, and Friday',
        classes: [
          { time: '5:35–6:25 PM', name: 'Beginner Class (ages 6 and up)' },
          { time: '6:35–7:30 PM', name: 'Advanced Class' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '10:00–11:00 AM', name: 'Bo Staff Class ($5 Drop-In)' },
          { time: '11:00 AM–12:00 PM', name: 'Beginner Class' },
          { time: '12:00–1:00 PM', name: 'Tang Soo Do' },
        ],
      },
    ],
  },
  {
    id: 'caro',
    name: 'Caro',
    city: 'Caro',
    address: '616 East Frank Street, Caro, Michigan',
    phone: GLOBAL_PHONE,
    highlights: ['Taekwondo', 'Brazilian Jiu-Jitsu', 'Family Classes'],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '5:15–6:15 PM', name: 'Zumba' },
          { time: '6:30–7:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
        ],
      },
      {
        day: 'Tuesday',
        classes: [
          { time: '5:30–6:50 PM', name: 'Brazilian Jiu-Jitsu (No-Gi)' },
          { time: '8:10–9:00 PM', name: 'Aerobic Kickboxing' },
        ],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '5:30–6:20 PM', name: 'Brazilian Jiu-Jitsu (Open Mat)' },
          { time: '6:30–7:00 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
        ],
      },
      {
        day: 'Thursday',
        classes: [
          { time: '5:30–6:50 PM', name: 'Brazilian Jiu-Jitsu (Gi)' },
          { time: '7:00–8:00 PM', name: 'Tae Kwon Do (ages 6 and up)' },
          { time: '8:10–9:00 PM', name: 'Aerobic Kickboxing' },
        ],
      },
      {
        day: 'Saturday',
        classes: [
          { time: '11:00 AM–12:00 PM', name: 'Brazilian Jiu-Jitsu (Open Mat)' },
          { time: '5:00–6:00 PM', name: 'Competition Class' },
        ],
      },
    ],
  },
  {
    id: 'bridgeport',
    name: 'Bridgeport',
    city: 'Bridgeport',
    address: '5126 Dixie Highway, Saginaw, Michigan',
    phone: GLOBAL_PHONE,
    highlights: ['Traditional Training', 'After School', 'Community Focused'],
    hasSchedule: true,
    schedule: [
      {
        day: 'Monday',
        classes: [
          { time: '4:20–4:50 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '5:00–5:55 PM', name: 'Novice Class (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advanced Class (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
        ],
      },
      {
        day: 'Wednesday',
        classes: [
          { time: '4:20–4:50 PM', name: 'Mini Kickers (ages 3–5)' },
          { time: '5:00–5:55 PM', name: 'Novice Class (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advanced Class (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
          { time: '8:00–9:00 PM', name: 'MMA Class' },
        ],
      },
      {
        day: 'Thursday',
        classes: [{ time: '7:00–8:00 PM', name: 'MMA Class' }],
      },
      {
        day: 'Friday',
        classes: [
          { time: '5:00–5:55 PM', name: 'Novice Class (ages 6 and up)' },
          { time: '6:00–6:55 PM', name: 'Advanced Class (ages 6 and up)' },
          { time: '7:00–7:55 PM', name: 'Tang Soo Do' },
        ],
      },
    ],
  },
  {
    id: 'hemlock',
    name: 'Hemlock',
    city: 'Hemlock',
    address: '14890 Gratiot Road, Hemlock, Michigan',
    phone: GLOBAL_PHONE,
    highlights: [
      'Beginner Friendly',
      'Small Class Sizes',
      'Personal Attention',
    ],
    hasSchedule: false,
  },
  {
    id: 'bay-city',
    name: 'Bay City',
    city: 'Bay City',
    address: '123 Main Street, Bay City, Michigan',
    phone: GLOBAL_PHONE,
    highlights: ['All Ages Welcome', 'Flexible Schedule', 'Family Classes'],
    hasSchedule: false,
  },
]

export function getLocationById(id: string): LocationData | undefined {
  return locations.find((loc) => loc.id === id)
}
